import { Component, Input, OnInit } from '@angular/core';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-popup-details',
  templateUrl: './popup-details.component.html',
  styleUrls: ['./popup-details.component.css']
})
export class PopupDetailsComponent implements OnInit {

  @Input() customData: any
  customerData: any = []

  mapData: any = []
  constructor(private generic_service: GenericService) { 
    // this.generic_service.menuToggle.subscribe((value) => {
      
    // });
  }

    

  ngOnInit(): void {
    this.mapData.push(this.customData)
    console.log(this.mapData)
  }

  imageUrl: any = ""
  imageUrlSelect(url:any){
    this.imageUrl = url
  }

  closeImage(){
    this.imageUrl = ""
  }

  viewData(){
    this.generic_service.customerView.next("");
  }

}

